/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { activityFollowersTypeHistogram } from '../fn/activity-analytics/activity-followers-type-histogram';
import { ActivityFollowersTypeHistogram$Params } from '../fn/activity-analytics/activity-followers-type-histogram';
import { ProfileAnalyticsTermItem } from '../models/profile-analytics-term-item';

@Injectable({ providedIn: 'root' })
export class ActivityAnalyticsService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `activityFollowersTypeHistogram()` */
  static readonly ActivityFollowersTypeHistogramPath = '/analytics/profile/{id}/well-dones/follower-type-histogram/{activityId}';

  /**
   * Get for activity well dones type histogram (for each of following count).
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `activityFollowersTypeHistogram()` instead.
   *
   * This method doesn't expect any request body.
   */
  activityFollowersTypeHistogram$Response(params: ActivityFollowersTypeHistogram$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<ProfileAnalyticsTermItem>>> {
    return activityFollowersTypeHistogram(this.http, this.rootUrl, params, context);
  }

  /**
   * Get for activity well dones type histogram (for each of following count).
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `activityFollowersTypeHistogram$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  activityFollowersTypeHistogram(params: ActivityFollowersTypeHistogram$Params, context?: HttpContext): Observable<Array<ProfileAnalyticsTermItem>> {
    return this.activityFollowersTypeHistogram$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<ProfileAnalyticsTermItem>>): Array<ProfileAnalyticsTermItem> => r.body)
    );
  }

}
